import { Button, Divider, Flex, Form, Typography } from 'antd';

import { formatDateToSubmit } from 'utilities/datesAndTimes';

import FundingAccountPicker from '../../FundingAccountPicker';
import PaymentPlanForm from '../PaymentPlanForm';
import PaymentsCalculatorCard from '../PaymentsCalculatorCard';
import { getMonthsUntilExpiration } from '../offerHelpers';
import {
  setFundingAccount,
  setPrecoPaymentDetails,
  setPrecoSchedule,
  usePrecoState,
} from './precoState';

const { Text } = Typography;

const PrecoPaymentPlanSetupStep = ({ onContinue }) => {
  const {
    offer,
    fundingAccount,
    cadence,
    startDate,
    durationMonths,
    schedule,
  } = usePrecoState();

  const [fundingAccountForm] = Form.useForm();
  const [planForm] = Form.useForm();

  const maxDurationMonths = getMonthsUntilExpiration(offer.expirationDate);

  const handlePaymentDetails = ({ cadence, startDate, duration }) => {
    setPrecoPaymentDetails({
      cadence,
      startDate: startDate ? formatDateToSubmit(startDate) : null,
      durationMonths: duration,
    });
  };

  const handleContinue = async () => {
    try {
      await fundingAccountForm.validateFields();
    } catch {
      return;
    }
    planForm.submit();
  };

  return (
    <Flex vertical={true} gap="var(--spacing)">
      <div>
        <Text strong>Select a Funding Account</Text>
        <FundingAccountPicker
          form={fundingAccountForm}
          fundingAccountId={fundingAccount?.id}
          onSelect={setFundingAccount}
        />
      </div>

      <Divider style={{ margin: 'var(--spacing-sm) 0' }} />

      <Text strong>Payment Plan Details</Text>

      <PaymentPlanForm
        form={planForm}
        embedded
        formName="precoModalPaymentDetailsForm"
        initialCadence={cadence}
        initialStartDate={startDate}
        initialDuration={durationMonths ?? maxDurationMonths}
        balance={offer.remainingBalance}
        expirationDate={offer.expirationDate}
        maxDurationMonths={maxDurationMonths}
        durationLabel="Enter Plan Duration (in months)"
        durationRequired={true}
        setPaymentDetails={handlePaymentDetails}
        setSchedule={setPrecoSchedule}
        onSubmit={onContinue}
        renderEstimatedPayments={(queryLoading) => (
          <PaymentsCalculatorCard
            loadingQuery={queryLoading}
            balanceLabel="Remaining Balance"
            balance={offer.remainingBalance}
            expirationDate={offer.expirationDate}
            startDate={startDate}
            cadence={cadence}
            schedule={schedule}
            durationMonths={durationMonths ?? maxDurationMonths}
          />
        )}
      />

      <Divider style={{ margin: 'var(--spacing-sm) 0' }} />

      <Flex justify="flex-end">
        <Button type="primary" onClick={handleContinue}>
          Continue
        </Button>
      </Flex>
    </Flex>
  );
};

export default PrecoPaymentPlanSetupStep;
